import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM12 9.74992C12.4142 9.74991 12.75 9.41411 12.75 8.9999C12.75 8.58569 12.4142 8.24991 12 8.24992L9.75 8.24999V6.00009C9.75 5.58588 9.41421 5.25009 9 5.25009C8.58579 5.25009 8.25 5.58588 8.25 6.00009V8.25003L5.99998 8.25009C5.58577 8.2501 5.24999 8.5859 5.25 9.00011C5.25001 9.41433 5.58581 9.7501 6.00002 9.75009L8.25 9.75003V12C8.25 12.4142 8.58579 12.75 9 12.75C9.41421 12.75 9.75 12.4142 9.75 12V9.74999L12 9.74992Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }